import { render, staticRenderFns } from "./faq-icon.vue?vue&type=template&id=9dbfcd0c&"
import script from "./faq-icon.vue?vue&type=script&lang=js&"
export * from "./faq-icon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports